import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import _ from 'lodash';

import JobPage from '../components/company/job-page';

const JobRoute = ({ job }) => (
  <Fragment>
    <DocumentTitle title={`${_.get(job, 'title', '')} | NerdWallet`} />
    <JobPage job={job} />
  </Fragment>
);

JobRoute.displayName = 'Job Route';
JobRoute.analyticsName = 'job_page';

JobRoute.propTypes = {
  job: PropTypes.object.isRequired,
};

export default connect((state) => ({ job: state.careersData.job }))(JobRoute);
